import {defineStore} from "pinia";
import {ref} from 'vue'
import storage from "@/utils/storage";
const useAccount = defineStore("account", () => {
    const account = ref( null);
    if (!account.value && storage.getWithExpiry('WEBSITE_PC_ACCOUNT_V2')) {
        account.value = JSON.parse(storage.getWithExpiry("WEBSITE_PC_ACCOUNT_V2"));
    }

    const getterAccount = () => {
        if (account.value) {
            return account.value.account;
        } else {
            if (storage.getWithExpiry("WEBSITE_PC_ACCOUNT_V2")) {
                account.value = JSON.parse(storage.getWithExpiry("WEBSITE_PC_ACCOUNT_V2"));
                return account.value.account;
            }
        }
        return null;
    }
    const getterAccountId = () => {
        if (account.value) {
            return account.value.invite_code;
        } else {
            if (storage.getWithExpiry("WEBSITE_PC_ACCOUNT_V2")) {
                account.value = JSON.parse(storage.getWithExpiry("WEBSITE_PC_ACCOUNT_V2"));
                return account.value.invite_code;
            }
        }
        return null;
    }

    const setterAccount = (value) => {
        account.value = value
    }

    return {
        account,
        getterAccount,
        setterAccount,
        getterAccountId
    }
})

export default useAccount